import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Application } from '../../../modules/app-catalog/domain/models/application';
import { AppSearchable } from '../../../modules/app-catalog/domain/models/app-interfaces';
import { ApplicationHelper } from '../../../modules/app-catalog/domain/services/application-helper';
import { TenantContextService } from '../../tenant-context/tenant-context.service';
import { take } from 'rxjs';
import { DatabricksLoginCheckService } from '../../services/databricks-login-check.service';
import { WindowService } from 'src/app/modules/data/data-entry/services/window.service';

@Component({
    selector: 'cdp-app-card',
    templateUrl: './app-card.component.html',
    styleUrls: ['./app-card.component.scss'],
    standalone: false
})
export class AppCardComponent implements OnInit {
    @Input() application: Application;
    @Input() searchText: AppSearchable[];
    @Input() isPreviewMode = false;
    @Output() updateLastView = new EventEmitter<Application>();
    @Output() toggleFavorite = new EventEmitter<Application>();
    hasLinks: boolean;
    themeColor = ApplicationHelper.defaultThemeColor;

    constructor(
        private tenantContext: TenantContextService,
        private databricksLoginCheckService: DatabricksLoginCheckService,
        private window: WindowService
    ) {}

    ngOnInit() {
        this.hasLinks = ApplicationHelper.hasLinks(this.application);
        this.tenantContext.tenantSelected$.pipe(take(1)).subscribe(tenant => {
            this.themeColor = tenant?.themeColor || ApplicationHelper.defaultThemeColor;
        });
    }

    async launch(event?: MouseEvent) {
        const url = this.application.url ?? '';
        if (url) {
            if (this.databricksLoginCheckService.isDatabricksUrl(url)) {
                if (await this.databricksLoginCheckService.showDbxAuthModal(url)) {
                    if (this.databricksLoginCheckService.isBaseUrl(url)) {
                        this.databricksLoginCheckService.handleBaseUrl(url);
                    } else {
                        this.databricksLoginCheckService.promptDbxLoginForExternalNavigation(url).subscribe();
                    }
                } else {
                    this.window.open(this.databricksLoginCheckService.getSanitizedTargetDbxUrl(url));
                }
            } else {
                this.window.open(this.databricksLoginCheckService.getLaunchUrl(url));
            }
            this.updateLastView.emit(this.application);
        } else {
            event?.stopPropagation();
            event?.preventDefault();
        }
    }

    favClicked(event?: MouseEvent): void {
        event?.stopPropagation();
        event?.preventDefault();
        if (this.isPreviewMode) {
            return;
        }
        this.toggleFavorite.emit(this.application);
    }
}
